import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})
class SpeechControlsPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onOptionChange(value) {
		var preferenceHash = {};
		preferenceHash = { speech_controls: value };
		this.props.onChange(preferenceHash, "You successfully changed the voice setting.");
	}

	render() {
		return (
			<div className="speechControlsPreferenceContainer">
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, "voice-first") }
						checked={ this.props.prefs.speech_controls == "voice-first" } />
					Voice-first: have questions and feedback read aloud automatically, highlight ability to speak answers
				</label><br />
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, "normal") }
						checked={ this.props.prefs.speech_controls == "normal" } />
					Voice optional: allow students to use voice and audio
				</label><br />
				<label>
					<input type="radio" onChange={ this.onOptionChange.bind(this, "off") }
						checked={ this.props.prefs.speech_controls == "off" } />
					No voice: remove all audio and voice capabilities
				</label>
				<p className="browserDisclaimer">
					Audio and voice capabilities require an updated version of Google Chrome, Mozilla Firefox, or Safari.
				</p>
			</div>
		)
	}
}


SpeechControlsPreference.propTypes = StrictPropTypes({
	prefs: PropTypes.object,
	onChange: PropTypes.func,
	populateData: PropTypes.func
});

module.exports = SpeechControlsPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/SpeechControlsPreference.js